import { Skeleton, Stack } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { isNullOrUndefined } from '@vy/utils';
import * as React from 'react';

type CustomerPortalNavBarProps = {
  logo?: string;
  customerName?: string;
  isLoading?: boolean;
};

export const CustomerPortalNavBar: React.FC<CustomerPortalNavBarProps> = ({
  logo,
  customerName,
  isLoading = false,
}) => {
  return (
    <AppBar
      position="sticky"
      sx={{
        backgroundColor: 'white',
        boxShadow: 'none',
        borderBottom: '1px solid rgba(13, 27, 39, 0.1)',
      }}
    >
      <Toolbar sx={{ justifyContent: 'center' }}>
        <Stack direction="row" sx={{ justifyContent: 'center', gap: 1 }}>
          <Box>
            {isLoading || isNullOrUndefined(logo) ? (
              <Skeleton variant="rectangular" width={120} height={28} />
            ) : (
              <img
                src={logo}
                style={{
                  height: '28px',
                }}
              />
            )}
          </Box>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1, color: 'black' }}>
            {customerName}
          </Typography>
        </Stack>
      </Toolbar>
    </AppBar>
  );
};
